import React, { useEffect, useRef, useState } from 'react';

const ComplaintMelSelector = ({
  ataChapters,
  ataChapter,
  selectedMelEntry,
  onAtaChange,
  onGeneralAta,
  onOpenMelEntries
}) => {
  const rootRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(null);
  const selectedChapter = ataChapters.find(item => String(item.chapter) === String(ataChapter));

  useEffect(() => {
    const closeOutside = event => {
      if (rootRef.current && !rootRef.current.contains(event.target)) setOpenMenu(null);
    };
    document.addEventListener('mousedown', closeOutside);
    return () => document.removeEventListener('mousedown', closeOutside);
  }, []);

  const selectChapter = chapter => {
    onAtaChange(chapter);
    setOpenMenu(null);
  };

  return (
    <div className="complaint-mel-selector" ref={rootRef}>
      <div className="fd-label">ATA Chapter</div>
      <div className={`complaint-select ${openMenu === 'ata' ? 'open' : ''}`}>
        <button type="button" className="complaint-select-trigger" onClick={() => setOpenMenu(current => current === 'ata' ? null : 'ata')}>
          <span className={selectedChapter ? 'has-value' : ''}>
            {selectedChapter ? `${selectedChapter.chapter} - ${selectedChapter.description}` : 'Select ATA Chapter'}
          </span>
          <span className="complaint-select-chevron" aria-hidden="true" />
        </button>
        {openMenu === 'ata' ? (
          <div className="complaint-select-menu complaint-ata-menu">
            {ataChapters.map(chapter => (
              <button
                key={chapter.id || chapter.chapter}
                type="button"
                className={`complaint-select-option ${String(chapter.chapter) === String(ataChapter) ? 'active' : ''}`}
                onClick={() => selectChapter(chapter)}
              >
                <span className="complaint-select-code">{chapter.chapter}</span>
                <span>{chapter.description}</span>
              </button>
            ))}
          </div>
        ) : null}
      </div>

      {ataChapter ? (
        <>
          <div className="fd-label">MEL Entry</div>
          <div className={`complaint-select ${openMenu === 'item' ? 'open' : ''}`}>
            <button type="button" className="complaint-select-trigger" onClick={() => setOpenMenu(current => current === 'item' ? null : 'item')}>
              <span className={selectedMelEntry ? 'has-value' : ''}>
                {selectedMelEntry
                  ? selectedMelEntry.title
                  : 'General ATA'}
              </span>
              <span className="complaint-select-chevron" aria-hidden="true" />
            </button>
            {openMenu === 'item' ? (
              <div className="complaint-select-menu complaint-mode-menu">
                <button
                  type="button"
                  className={`complaint-select-option complaint-mode-option ${selectedMelEntry ? '' : 'active'}`}
                  onClick={() => {
                    onGeneralAta();
                    setOpenMenu(null);
                  }}
                >
                  <span>General ATA</span>
                  <small>Enter the defect description manually</small>
                </button>
                <button
                  type="button"
                  className="complaint-select-option complaint-mode-option"
                  onClick={() => {
                    onOpenMelEntries();
                    setOpenMenu(null);
                  }}
                >
                  <span>Select MEL Entry from List</span>
                  <small>Browse MEL Entries for this ATA chapter</small>
                </button>
              </div>
            ) : null}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default ComplaintMelSelector;
